import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { verifyEmailChange } from 'services/userService';
import store from 'store';

const VerifyEmail = () => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const handleLogout = () => {
    store.remove('token');
    window.location.href = '/';
  };

  useEffect(() => {
    const verifyToken = async () => {
      const params = new URLSearchParams(location.search);
      const changeToken = params.get('token');

      if (!changeToken) {
        setLoading(false);
        setMessage('Invalid verification link.');
        return;
      }

      try {
        const response = await verifyEmailChange({ changeToken });
        setLoading(false);
        setMessage('Email verified successfully.');
        handleLogout();
      } catch (error) {
        setLoading(false);
        setMessage(
          'Error verifying email. The link may have expired or is invalid.'
        );
      }
    };

    verifyToken();
  }, [location]);

  if (loading) {
    return <div>Validating...</div>;
  }

  return <div>{message}</div>;
};

export default VerifyEmail;
